import axios from 'axios'

import { AgentModel } from '../model/agent.model'

export default class AgentService {
  constructor(private host: string) {}

  URL = `${this.host}/profiles/v1/context`

  fetchAgentData(): Promise<AgentModel> {
    return axios.get(this.URL).then((response) => response.data)
  }
}
